import React from 'react';
import style from './Recipes.module.css';


const Recipe = ({image, title, calories, ingredients }) => {
    return(
        <div className={style.recipe}>
            <h1>{title}</h1>
            
            <ol>
            <h3>Ingredients:</h3>
                {ingredients.map(ingredient => (
                    <li className={style.list}>{ingredient.text}</li>
                ))}
            </ol>
            <p className={style.calories}>Calories: {calories}</p>
            <img className={style.image} src={image} alt="Dish" />
        </div>
    );
};

export default Recipe;